var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatIcon"},[_c('div',{staticClass:"emotionList"},_vm._l((_vm.faceList),function(item,index){return _c('a',{key:index,staticClass:"emotionItem",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.getEmo(item)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }